import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.insertIndex = 0
    this.boundKeydown = this.handleKeydown.bind(this)
  }

  open(event) {
    this.insertIndex = Number(event.detail?.insertIndex ?? 0)
    this.overlayTarget.classList.add("is-open")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.boundKeydown)
  }

  close() {
    this.overlayTarget.classList.remove("is-open")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.boundKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  pick(event) {
    const sectionType = event.currentTarget.dataset.sectionType
    if (!sectionType) return

    window.dispatchEvent(new CustomEvent("profile-page-designer:pick", {
      detail: {
        insertIndex: this.insertIndex,
        sectionType
      }
    }))

    this.close()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
